// extracted by mini-css-extract-plugin
export var customCol = "content-grid-module--customCol--76ceb";
export var customGrid = "content-grid-module--customGrid--4e16f";
export var heading = "content-grid-module--heading--96628";
export var root = "content-grid-module--root--ac442";